<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import moment from 'moment'
import { crudMethods } from '@/src/state/helpers'

// Import Sub Komponen
import PanjarModal from '@/src/router/views/pages/monitoring/component/panjar-modal.vue'
import ProjectFilter from '@/src/router/views/pages/monitoring/component/project-filter.vue'
import ProjectTable from '@/src/router/views/pages/monitoring/component/project-table.vue'
import SphModal from '@/src/router/views/pages/monitoring/component/sph-modal.vue'
import TagihanModal from '@/src/router/views/pages/monitoring/component/tagihan-modal.vue'
import DetailProyekModal from '@/src/router/views/pages/monitoring/component/detail-proyek-modal.vue'

export default {
  page: {
    title: 'Monitoring Proyek',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    ProjectFilter,
    ProjectTable,
    SphModal,
    PanjarModal,
    TagihanModal,
    DetailProyekModal,
  },
  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {},
      title: 'Monitoring Proyek',
      subtitle: 'Monitoring Semua Proyek Yang Telah dan Masih Berjalan',
      url: '/web/monitoring/proyek',
      rows: 1,
      perPage: 50,
      currentPage: 1,
      from: 1,
      to: 1,
      total: 1,
      qCari: '',
      items: [],
      year: moment().format('YYYY'),

      // State Modal SPH
      modalDetailSph: false,
      loadingDetailSph: false,
      dataSphRows: [],
      selectedProyekName: '',
      selectedProyekKode: '',

      // State Modal Panjar
      modalDetailPanjar: false,
      loadingDetailPanjar: false,
      dataPanjarRows: [],

      // State Modal Tagihan
      modalDetailTagihan: false,
      loadingDetailTagihan: false,
      dataTagihanRows: [],

      modalDetailProyek: false,
      dataProyekRow: {},
    }
  },
  watch: {
    items(newVal) {
      if (newVal) {
        newVal.forEach((item, index) => {
          item['no'] = index + this.from
        })
      }
    },
    year() {
      this.currentPage = 1
      this.getList()
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...crudMethods,
    getList() {
      this.listData({
        url: `${this.url}?page=${this.currentPage}&q=${this.qCari}&per_page=${this.perPage}&year=${this.year}`,
      }).then((response) => {
        const resData = response.data
        this.items = resData.data || []

        this.rows = resData.total
        this.perPage = resData.per_page
        this.currentPage = resData.current_page
        this.to = resData.to
        this.total = resData.total
        this.from = resData.from
      })
    },
    formatRupiah(value) {
      if (value === null || value === undefined) return 'Rp0'
      return 'Rp' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    dateFormat(value) {
      if (!value) return '-'
      moment.locale('id')
      return moment(value).format('DD MMM YYYY')
    },
    exportData(type) {
      const downloadUrl = `web/monitoring/proyek/export?type=${type}&q=${this.qCari}&year=${this.year}`

      this.downloadData({ url: downloadUrl })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const extension = type === 'pdf' ? 'pdf' : 'xlsx'
          const filename = `Monitoring_Proyek_Tahun_${
            this.year
          }_${moment().format('YYYYMMDDHHmmss')}.${extension}`

          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error('Gagal mengekspor data:', error)
        })
    },
    exportDetailData(item, type = 'excel') {
      // Tambahkan parameter proyek_id ke URL agar backend tahu proyek mana yang diexport
      const downloadUrl = `web/monitoring/proyek/detail/export?proyek_id=${item.proyek_id}&type=${type}`

      this.downloadData({ url: downloadUrl })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const extension = type === 'pdf' ? 'pdf' : 'xlsx'

          // Nama file disesuaikan dengan kode proyek agar lebih informatif
          const cleanKodeProyek = item.kode_proyek.replace(
            /[/\\?%*:|"<>\s]/g,
            '_'
          )
          const filename = `Detail_Finansial_${cleanKodeProyek}_${moment().format(
            'YYYYMMDDHHmmss'
          )}.${extension}`

          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error('Gagal mengekspor data detail proyek:', error)
        })
    },
    lihatDetailSph(row) {
      this.selectedProyekName = row.nama_proyek
      this.selectedProyekKode = row.kode_proyek
      this.dataSphRows = []
      this.modalDetailSph = true
      this.loadingDetailSph = true

      this.listData({ url: `web/transaksi/proyek/${row.proyek_id}/rab` })
        .then((response) => {
          this.dataSphRows = response.data.data || response.data || []
        })
        .catch((error) => {
          console.error('Gagal memuat detail RAB SPH:', error)
          this.$bvToast.toast('Gagal mengambil data rincian RAB', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        })
        .finally(() => {
          this.loadingDetailSph = false
        })
    },
    lihatDetailPanjar(row, statusFilter = 'ALL') {
      this.selectedProyekName = row.nama_proyek
      this.selectedProyekKode = row.kode_proyek
      this.dataPanjarRows = []
      this.modalDetailPanjar = true
      this.loadingDetailPanjar = true

      this.listData({ url: `web/transaksi/proyek/${row.proyek_id}/panjar` })
        .then((response) => {
          // Ambil raw data dari response API
          const rawData = response.data.data || response.data || []

          // Filter data berdasarkan parameter statusFilter
          if (statusFilter === 'SUDAH_BAYAR') {
            // Hanya mengambil yang status_panjar-nya 'SELESAI'
            this.dataPanjarRows = rawData.filter(
              (item) => item.status_panjar === 'SELESAI'
            )
          } else if (statusFilter === 'BELUM_BAYAR') {
            // Mengambil yang status_panjar-nya 'PROSES' atau null / undefined / kosong
            this.dataPanjarRows = rawData.filter(
              (item) => item.status_panjar === 'PROSES' || !item.status_panjar
            )
          } else {
            // Tampilkan semua data jika tidak difilter spesifik
            this.dataPanjarRows = rawData
          }
        })
        .catch((error) => {
          console.error('Gagal memuat detail Panjar:', error)
          this.$bvToast.toast('Gagal mengambil data rincian pembayaran mitra', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.modalDetailPanjar = false
        })
        .finally(() => {
          this.loadingDetailPanjar = false
        })
    },
    lihatDetailTagihan(row, type = 'sudah_ditagih') {
      this.selectedProyekName = row.nama_proyek
      this.selectedProyekKode = row.kode_proyek
      this.dataTagihanRows = []
      this.modalDetailTagihan = true
      this.loadingDetailTagihan = true

      // Ubah label berdasarkan tipe klik (opsional, untuk memperjelas tampilan modal)
      const labelMap = {
        sudah_ditagih: 'Sudah Ditagih',
        belum_ditagih: 'Belum Ditagih',
        sudah_dibayar: 'Sudah Dibayar',
        belum_dibayar: 'Belum Dibayar',
      }
      this.labelStatusTagihan = labelMap[type] || 'Detail Tagihan'

      this.listData({
        url: `web/monitoring/proyek/detail-tagihan?proyek_id=${row.proyek_id}`,
      })
        .then((response) => {
          const rawData = response.data.data || response.data || []

          // --- PROSES FILTER DI SISI CLIENT ---
          if (type === 'belum_ditagih') {
            this.dataTagihanRows = rawData.filter(
              (item) => item.tanggal_ditagih === null
            )
          } else if (type === 'sudah_dibayar') {
            this.dataTagihanRows = rawData.filter(
              (item) => item.tanggal_bayar !== null
            )
          } else if (type === 'belum_dibayar') {
            this.dataTagihanRows = rawData.filter(
              (item) =>
                item.tanggal_ditagih !== null && item.tanggal_bayar === null
            )
          } else {
            // Default: Sudah Ditagih (menampilkan yang memiliki tanggal_ditagih)
            this.dataTagihanRows = rawData.filter(
              (item) => item.tanggal_ditagih !== null
            )
          }
        })
        .catch((error) => {
          console.error('Gagal memuat detail Tagihan:', error)
          this.$bvToast.toast('Gagal mengambil rincian riwayat tagihan', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
          this.modalDetailTagihan = false
        })
        .finally(() => {
          this.loadingDetailTagihan = false
        })
    },
    bukaDetailProyek(row) {
      this.selectedProyekName = row.nama_proyek
      this.selectedProyekKode = row.kode_proyek
      this.dataProyekRow = row // Menyimpan data row utuh
      this.modalDetailProyek = true
    },
    hitungTotalSphRow(rab) {
      if (!rab) return 0
      const sph = parseFloat(rab.sph) || 0
      const vol = parseFloat(rab.volume) || 0
      const per = parseFloat(rab.periode) || 0

      if (rab.sph_kali === 'all') return sph * vol * per
      if (rab.sph_kali === 'volume') return sph * vol
      if (rab.sph_kali === 'periode') return sph * per
      return 0
    },
    hitungTotalSpkRow(rab) {
      if (!rab) return 0
      const spk = parseFloat(rab.spk) || 0
      const vol = parseFloat(rab.volume) || 0
      const per = parseFloat(rab.periode) || 0

      if (rab.spk_kali === 'all') return spk * vol * per
      if (rab.spk_kali === 'volume') return spk * vol
      if (rab.spk_kali === 'periode') return spk * per
      return spk * vol * per
    },
    hitungTotalPanjarRow(item) {
      const dpp = parseFloat(item.nilai_dpp) || 0
      const ppn = parseFloat(item.ppn) || 0
      const ppnNominal = (dpp * ppn) / 100
      const totalBiayaLain = item.biaya_lains
        ? item.biaya_lains.reduce(
            (sum, b) => sum + (parseFloat(b.biaya) || 0),
            0
          )
        : 0
      return dpp + ppnNominal + totalBiayaLain
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row mt-4">
      <div class="col-lg-12">
        <div class="card p-3 border-radius-2 mb-0">
          <!-- Komponen Filter -->
          <ProjectFilter
            :year.sync="year"
            :q-cari.sync="qCari"
            @search="getList"
            @export="exportData"
          />

          <!-- Komponen Tabel Utama -->
          <ProjectTable
            :items="items"
            :format-rupiah="formatRupiah"
            @click-sph="lihatDetailSph"
            @click-panjar="lihatDetailPanjar"
            @click-tagihan="lihatDetailTagihan"
            @click-detail="bukaDetailProyek"
            @click-download="exportDetailData($event, 'excel')"
          />

          <div class="row mt-4">
            <div class="col-sm-12 col-md-6"
              ><p>Data {{ from }} ke {{ to }} dari {{ total }} data</p></div
            >
            <div class="col-sm-12 col-md-6">
              <div class="text-md-right">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  class="d-inline-flex"
                  @input="getList"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Komponen Modal SPH -->
    <SphModal
      v-model="modalDetailSph"
      :loading="loadingDetailSph"
      :project-name="selectedProyekName"
      :project-code="selectedProyekKode"
      :data-rows="dataSphRows"
      :format-rupiah="formatRupiah"
      :hitung-total-sph-row="hitungTotalSphRow"
      :hitung-total-spk-row="hitungTotalSpkRow"
    />

    <!-- Komponen Modal Panjar -->
    <PanjarModal
      v-model="modalDetailPanjar"
      :loading="loadingDetailPanjar"
      :project-name="selectedProyekName"
      :project-code="selectedProyekKode"
      :data-rows="dataPanjarRows"
      :format-rupiah="formatRupiah"
      :date-format="dateFormat"
      :hitung-total-panjar-row="hitungTotalPanjarRow"
    />

    <!-- Komponen Modal Tagihan -->
    <TagihanModal
      v-model="modalDetailTagihan"
      :loading="loadingDetailTagihan"
      :project-name="selectedProyekName"
      :project-code="selectedProyekKode"
      :data-rows="dataTagihanRows"
      :format-rupiah="formatRupiah"
      :date-format="dateFormat"
    />

    <DetailProyekModal
      v-model="modalDetailProyek"
      :project-name="selectedProyekName"
      :project-code="selectedProyekKode"
      :nilai-proyek="dataProyekRow.nilai_proyek"
      :beban-proyek="dataProyekRow.beban_proyek"
      :sudah-ditagih="dataProyekRow.sudah_ditagih_ke_pemberi_kerja"
      :belum-ditagih="dataProyekRow.belum_ditagih_ke_pemberi_kerja"
      :sudah-bayar-customer="dataProyekRow.sudah_dibayar_pemberi_kerja"
      :belum-bayar-customer="dataProyekRow.belum_dibayar_pemberi_kerja"
      :sudah-bayar-mitra="dataProyekRow.sudah_dibayar_ke_mitra"
      :belum-bayar-mitra="dataProyekRow.belum_dibayar_ke_mitra"
      :format-rupiah="formatRupiah"
    />
  </Layout>
</template>

<style lang="scss">
.action-list {
  display: flex;
  gap: 12px;
  align-items: center;

  .dropdown-float {
    position: relative;
    span {
      position: absolute;
      top: -9px;
      left: 10px;
      font-size: 11px;
      font-weight: 600;
      z-index: 10;
      background-color: #fff;
      padding: 0 4px;
      color: #555;
    }
    select {
      height: 38px;
      color: #000;
      font-weight: 600;
      border-radius: 4px;
      border: 1px solid #ccc;
    }
  }

  .search-input {
    position: relative;
    flex: 1;
    input {
      height: 38px;
      border-radius: 4px;
      padding-right: 40px;
    }
    .search-icon {
      position: absolute;
      right: 12px;
      top: 10px;
      cursor: pointer;
      color: #6c757d;
      width: 18px;
    }
  }
}

.width-200-px {
  width: 200px;
}
.font-weight-medium {
  font-weight: 600;
}
.bg-white-disabled {
  background-color: #f1f1f1 !important;
}
.custom-table-modal {
  font-size: 13px;
  th {
    background-color: #f8f9fa;
    font-weight: 700;
  }
}
</style>
